import { useTranslation } from "react-i18next";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useContractorContext } from "../context";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { Module } from "@/constants";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useState } from "react";
import ContractorUpdateForm from "./ContractorUpdateForm";

const ContractorUpdate = () => {
  const { t } = useTranslation();
  const { can_delete } = useModulePermissions(Module.Contractors);
  const { handleDelete } = useContractorContext();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const onDelete = () => {
    handleDelete();
    setIsDeleteDialogOpen(false);
  };

  return (
    <div className="space-y-6">
      <ContractorUpdateForm />

      {can_delete && (
        <div className="flex justify-end">
          <AlertDialog
            open={isDeleteDialogOpen}
            onOpenChange={setIsDeleteDialogOpen}
          >
            <AlertDialogTrigger asChild>
              <Button type="button" variant="destructive">
                <Trash2 className="mr-2 h-4 w-4" />
                {t("contractors.delete.button")}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>
                  {t("contractors.delete.title")}
                </AlertDialogTitle>
                <AlertDialogDescription>
                  {t("contractors.delete.confirm")}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
                <AlertDialogAction
                  onClick={onDelete}
                  className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                >
                  {t("contractors.delete.button")}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      )}
    </div>
  );
};

export default ContractorUpdate;
